export const overrideText = (original: string, override?: string) => {
  return override ? override : original
}
